export const composeContexts = (providers: any[]) =>
  providers.reduce((Prev, Curr) => ({ children }: { children: React.ReactNode }) => (
    <Prev>
      <Curr>{children}</Curr>
    </Prev>
  ))
